const CHANNEL_PREFIX = 'Channel::';

const formatChannelType = type => {
  if (!type) {
    return null;
  }

  const normalized = type.startsWith(CHANNEL_PREFIX)
    ? type.slice(CHANNEL_PREFIX.length)
    : type;

  return normalized
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const getContactChannelNames = contact => {
  if (!contact) {
    return [];
  }

  const contactInboxes = contact.contact_inboxes || contact.contactInboxes;

  if (!Array.isArray(contactInboxes) || !contactInboxes.length) {
    return [];
  }

  const names = contactInboxes
    .map(contactInbox => {
      const inboxData = contactInbox?.inbox || contactInbox;

      const explicitName =
        inboxData?.name ||
        contactInbox?.name;

      if (explicitName) {
        return explicitName;
      }

      const channelType =
        inboxData?.channel_type ||
        inboxData?.channelType ||
        contactInbox?.channel_type ||
        contactInbox?.channelType;

      return formatChannelType(channelType);
    })
    .filter(Boolean);

  return [...new Set(names)];
};
